import { render, staticRenderFns } from "./CarouselImage.vue?vue&type=template&id=283f5b18&scoped=true&"
import script from "./CarouselImage.vue?vue&type=script&lang=js&"
export * from "./CarouselImage.vue?vue&type=script&lang=js&"
import style0 from "./CarouselImage.vue?vue&type=style&index=0&id=283f5b18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283f5b18",
  null
  
)

export default component.exports